import { render, staticRenderFns } from "./arinvrealisasi.vue?vue&type=template&id=08f981e9"
import script from "./arinvrealisasi.vue?vue&type=script&lang=js"
export * from "./arinvrealisasi.vue?vue&type=script&lang=js"
import style0 from "./arinvrealisasi.vue?vue&type=style&index=0&id=08f981e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports